import { supabase } from './client';

export async function uploadFile(bucket: string, path: string, file: File | Blob) {
  const { data, error } = await supabase.storage.from(bucket).upload(path, file, { upsert: true });
  if (error) throw error;
  return data;
}

export function getPublicUrl(bucket: string, path: string) {
  const { data } = supabase.storage.from(bucket).getPublicUrl(path);
  return data.publicUrl;
}

export async function removeFile(bucket: string, path: string) {
  const { error } = await supabase.storage.from(bucket).remove([path]);
  if (error) throw error;
  return true;
}

export async function listUserFiles(userId: string, fileType: 'profile' | 'document' | 'application' | 'appointment' | 'general') {
  const bucket = 'user-files';
  const prefix = `${fileType}/${userId}`;
  const { data, error } = await supabase.storage.from(bucket).list(prefix, { 
    limit: 100, 
    sortBy: { column: 'name', order: 'asc' } 
  });
  if (error) throw error;

  return (data || []).filter(item => item.name).map((item) => {
    const path = `${prefix}/${item.name}`;
    const url = getPublicUrl(bucket, path);
    return {
      id: item.id || item.name,
      name: item.name,
      size: (item as any).metadata?.size ?? 0,
      type: 'application/octet-stream',
      url,
      path,
      uploadedAt: new Date(),
      userId,
      category: fileType
    };
  });
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}
